<template>
    <div class="modal-overlay" :class="{ 'is-open': visible }" @click="closeModal">
        <div class="modal-box" :class="{ 'is-open': visible }" @click.stop>

            <!-- Close Button -->
            <button class="close-btn" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>

            <!-- Sidebar -->
            <aside class="sidebar">
                <div class="user-summary">
                    <div class="avatar-wrapper">
                        <UserAvatar></UserAvatar>
                        <!-- <img src="@/assets/images/user_man.png" alt="avatar" />
                        <div class="status-dot"></div> -->
                    </div>
                    <h3>{{ userStore.name }}</h3>
                    <span class="badge">{{ userStore.userRole }}</span>
                </div>

                <nav class="tab-nav">
                    <button class="tab-btn" :class="{ active: currentTab === 'profile' }"
                        @click="currentTab = 'profile'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                        </svg>
                        <span>{{ $t('profileModal.basicInfo') }}</span>
                    </button>
                    <button class="tab-btn" :class="{ active: currentTab === 'security' }"
                        @click="currentTab = 'security'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            <path d="m9 12 2 2 4-4" />
                        </svg>
                        <span>{{ $t('profileModal.securitySettings') }}</span>
                    </button>
                    <!-- <button class="tab-btn" :class="{ active: currentTab === 'settings' }"
                        @click="currentTab = 'settings'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="3" />
                            <path
                                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                        </svg>
                        <span>{{ $t('profileModal.systemSettings') }}</span>
                    </button> -->
                </nav>

                <div class="sidebar-footer">
                    <button class="logout-btn" @click="logout">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                        {{ $t('profileModal.logout') }}
                    </button>
                </div>
            </aside>

            <!-- Main Tab Content -->
            <main class="tab-content-container">

                <!-- Tab 1: Profile (Element Plus Form) -->
                <div class="tab-pane" v-show="currentTab === 'profile'">
                    <div class="pane-header">
                        <h2>{{ $t('profileModal.basicInfo') }}</h2>
                        <p>{{ $t('profileModal.basicInfoDesc') }}</p>
                    </div>

                    <el-form ref="profileRef" :model="userForm" :rules="iforule" label-position="top" size="large"
                        class="custom-el-form">
                        <el-form-item :label="$t('profileModal.nickName')" prop="nickName">
                            <el-input v-model="userForm.nickName" :placeholder="$t('profileModal.nickNamePlaceholder')" />
                        </el-form-item>
                        <el-form-item :label="$t('profileModal.phone')" prop="phonenumber">
                            <el-input v-model="userForm.phonenumber" :placeholder="$t('profileModal.phonePlaceholder')" />
                        </el-form-item>
                        <el-form-item :label="$t('profileModal.email')" prop="email">
                            <el-input v-model="userForm.email" :placeholder="$t('profileModal.emailPlaceholder')" />
                        </el-form-item>
                        <el-form-item :label="$t('profileModal.gender')">
                            <el-radio-group v-model="userForm.sex">
                                <el-radio value="0">{{ $t('profileModal.male') }}</el-radio>
                                <el-radio value="1">{{ $t('profileModal.female') }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                    <div class="pane-footer">
                        <el-button type="primary" size="large" @click="saveProfile">{{ $t('profileModal.saveProfile') }}</el-button>
                    </div>
                </div>

                <!-- Tab 2: Security (Element Plus Form) -->
                <div class="tab-pane" v-show="currentTab === 'security'">
                    <div class="pane-header">
                        <h2>{{ $t('profileModal.securitySettings') }}</h2>
                        <p>{{ $t('profileModal.securitySettingsDesc') }}</p>
                    </div>

                    <div class="security-card">
                        <h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4l-4 4z" />
                                <path d="m2 22 2-2" />
                                <path d="m4.6 21.6 3.8-3.8" />
                                <path d="m7.2 21.2 3.8-3.8" />
                                <path d="M12.6 15.6 16 12.2" />
                                <circle cx="10" cy="14" r="2" />
                            </svg>
                            {{ $t('profileModal.changePassword') }}
                        </h3>

                        <el-form ref="pwdRef" :model="securityInfo" :rules="securityRule" label-position="top"
                            size="large" class="custom-el-form">
                            <el-form-item :label="$t('profileModal.currentPassword')" prop="oldPassword" class="compact-label">
                                <el-input v-model="securityInfo.oldPassword" type="password" show-password
                                    :placeholder="$t('profileModal.currentPasswordPlaceholder')" />
                            </el-form-item>

                            <!-- <el-divider border-style="dashed" /> -->

                            <el-form-item :label="$t('profileModal.newPassword')" prop="newPassword" class="compact-label" style="margin-bottom: 8px;">
                                <el-input v-model="securityInfo.newPassword" type="password" show-password
                                    :placeholder="$t('profileModal.newPasswordPlaceholder')" />
                            </el-form-item>

                            <!-- <div class="password-strength">
                                <div class="bar red"></div>
                                <div class="bar amber"></div>
                                <div class="bar gray"></div>
                            </div>
                            <p class="strength-text">密码强度：中等</p> -->

                            <el-form-item :label="$t('profileModal.confirmPassword')" prop="confirmPassword" class="compact-label" style="margin-top: 16px;">
                                <el-input v-model="securityInfo.confirmPassword" type="password" show-password
                                    :placeholder="$t('profileModal.confirmPasswordPlaceholder')" />
                            </el-form-item>

                            <el-button color="#1e293b" size="large" class="w-full mt-4 btn-dark" @click="triggerToast">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" style="margin-right: 8px;">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                    <path d="m9 12 2 2 4-4" />
                                </svg>
                                {{ $t('profileModal.updatePassword') }}
                            </el-button>
                        </el-form>
                    </div>
                </div>

                <!-- Tab 3: Settings -->
                <div class="tab-pane" v-show="currentTab === 'settings'">
                    <div class="pane-header">
                        <h2>{{ $t('profileModal.systemSettings') }}</h2>
                        <p>{{ $t('profileModal.systemSettingsDesc') }}</p>
                    </div>
                    <div class="settings-section">
                        <h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <path
                                    d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                                <path d="M2 12h20" />
                            </svg>
                            {{ $t('profileModal.languageRegion') }}
                        </h3>
                        <div class="radio-list-card">

                            <label class="radio-card-item">
                                <div class="item-left">
                                    <div class="icon-box" :class="{ active: settingsLang === 'zh' }">{{ $t('headerWidgets.langBadgeZh') }}</div>
                                    <div>
                                        <p class="title">{{ $t('profileModal.chineseSimplified') }}</p>
                                        <p class="subtitle">{{ $t('profileModal.chineseSimplifiedSub') }}</p>
                                    </div>
                                </div>
                                <div class="item-right">
                                    <input type="radio" v-model="settingsLang" value="zh" />
                                    <div class="custom-radio">
                                        <svg v-if="settingsLang === 'zh'" xmlns="http://www.w3.org/2000/svg" width="12"
                                            height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                    </div>
                                </div>
                            </label>

                            <label class="radio-card-item">
                                <div class="item-left">
                                    <div class="icon-box" :class="{ active: settingsLang === 'en' }">En</div>
                                    <div>
                                        <p class="title">{{ $t('profileModal.english') }}</p>
                                        <p class="subtitle">{{ $t('profileModal.englishSub') }}</p>
                                    </div>
                                </div>
                                <div class="item-right">
                                    <input type="radio" v-model="settingsLang" value="en" />
                                    <div class="custom-radio">
                                        <svg v-if="settingsLang === 'en'" xmlns="http://www.w3.org/2000/svg" width="12"
                                            height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                    </div>
                                </div>
                            </label>

                            <label class="radio-card-item">
                                <div class="item-left">
                                    <div class="icon-box" :class="{ active: settingsLang === 'auto' }">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                            <line x1="8" y1="21" x2="16" y2="21" />
                                            <line x1="12" y1="17" x2="12" y2="21" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p class="title">{{ $t('profileModal.systemDefault') }}</p>
                                        <p class="subtitle">{{ $t('profileModal.systemDefaultSub') }}</p>
                                    </div>
                                </div>
                                <div class="item-right">
                                    <input type="radio" v-model="settingsLang" value="auto" />
                                    <div class="custom-radio">
                                        <svg v-if="settingsLang === 'auto'" xmlns="http://www.w3.org/2000/svg"
                                            width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white"
                                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                    </div>
                                </div>
                            </label>

                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import useUserStore from '@/store/modules/user';
import { getAuthList } from '@/api/system/social/auth';
import { getUserProfile, updateUserProfile } from '@/api/system/user';
import { getOnline } from '@/api/monitor/online';
import { UserVO } from '@/api/system/user/types';
import { updateUserPwd } from '@/api/system/user';
import UserAvatar from './userAvatar.vue';
import { useI18n } from 'vue-i18n';
import { getTenantLoginUrl } from '@/utils/tenantRoute';
const {t} = useI18n();
const userStore = useUserStore();
const props = defineProps({
    visible: {
        type: Boolean,
        default: true
    }
});
const { proxy } = getCurrentInstance()
const profileRef = ref();
const pwdRef = ref();
const iforule = {
    nickName: [{ required: true, message: t('profileModal.nickNameRequired'), trigger: 'blur' }],
    email: [
        { required: true, message: t('profileModal.emailRequired'), trigger: 'blur' },
        {
            type: 'email' as any,
            message: t('profileModal.emailInvalid'),
            trigger: ['blur', 'change']
        }
    ],
    phonenumber: [
        {
            required: true,
            message: t('profileModal.phoneRequired'),
            trigger: 'blur'
        },
        { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: t('profileModal.phoneInvalid'), trigger: 'blur' }
    ]
};

/**
 * 从个人资料弹窗注销，并跳转到携带当前租户 ID 的登录页。
 * @returns {Promise<void>} 注销接口完成并触发整页跳转后结束
 * @sideeffect 清除用户登录态，并通过 location.href 重新加载登录页
 */
const logout = async () => {
  await ElMessageBox.confirm(t('navbar.logoutConfirmMessage'), t('navbar.logoutConfirmTitle'), {
    confirmButtonText: t('navbar.confirm'),
    cancelButtonText: t('navbar.cancel'),
    type: 'warning',
    customClass: 'night-message-box'
  });
  // 先保存租户 ID 再注销，防止登录态清理后无法构造租户专属登录地址。
  const logoutTenantId = userStore.tenantId;
  await userStore.logout();
  location.href = getTenantLoginUrl(logoutTenantId);
};
const equalToPassword = (rule: any, value: string, callback: any) => {
    if (securityInfo.value.newPassword !== value) {
        callback(new Error(t('profileModal.passwordMismatch')));
    } else {
        callback();
    }
};
const securityRule = {
    oldPassword: [{ required: true, message: t('profileModal.oldPasswordRequired'), trigger: 'blur' }],
    newPassword: [
        { required: true, message: t('profileModal.newPasswordRequired'), trigger: 'blur' },
        {
            min: 6,
            max: 20,
            message: t('profileModal.passwordLength'),
            trigger: 'blur'
        },
        { pattern: /^[^<>"'|\\]+$/, message: t('profileModal.passwordInvalidChars') +"< > \' \\\ |", trigger: 'blur' }
    ],
    confirmPassword: [
        { required: true, message: t('profileModal.confirmPasswordRequired'), trigger: 'blur' },
        {
            required: true,
            validator: equalToPassword,
            trigger: 'blur'
        }
    ]
}
const emit = defineEmits(['close']);
const securityForm = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
}
onMounted(() => {
    getUser();
    getAuths();
    getOnlines();
    console.log(userStore);
});

const currentTab = ref('profile');
const settingsLang = ref('zh');
const isToastVisible = ref(false);

const userInfo = ref({
    name: userStore.name,
    phone: userStore.phone,
    email: 'sun.chao@sky-pivot.com',
    gender: 'male'
});

const securityInfo = ref({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
});
watch(currentTab, (val) => {
    if (val === 'profile') {
        // 恢复基本信息数据
        userForm.value = { ...state.value.user };
        // 延迟一下，等待 DOM 渲染后清空校验状态
        nextTick(() => {
            profileRef.value?.clearValidate();
        });
    }
    if (val === 'security') {
        // 清空密码表单
        securityInfo.value = { oldPassword: '', newPassword: '', confirmPassword: '' };
        nextTick(() => {
            pwdRef.value?.clearValidate();
        });
    }
});
const closeModal = () => {
    emit('close', false);
};

const saveProfile = () => {
    profileRef.value?.validate(async (valid: boolean) => {
    if (valid) {
      await updateUserProfile(userForm.value);
      proxy?.$modal.msgSuccess(t('profileModal.updateSuccess'));
    }
  });
};

const triggerToast = () => {
    pwdRef.value?.validate(async (valid: boolean) => {
        if (valid) {
            // 这里应该使用 securityInfo 的值
            await updateUserPwd(securityInfo.value.oldPassword, securityInfo.value.newPassword);
            proxy?.$modal.msgSuccess(t('profileModal.updateSuccess'));

            // 提交成功后可选择重置表单
            securityInfo.value = { oldPassword: '', newPassword: '', confirmPassword: '' };
            pwdRef.value?.resetFields();
        }
    });
};
interface State {
    user: Partial<UserVO>;
    roleGroup: string;
    postGroup: string;
    auths: any;
    devices: any;
}
const userForm = ref({});
const state = ref<State>({
    user: {},
    roleGroup: '',
    postGroup: '',
    auths: [],
    devices: []
});
const getUser = async () => {
    const res = await getUserProfile();
    state.value.user = res.data.user;
    userForm.value = { ...res.data.user };
    state.value.roleGroup = res.data.roleGroup;
    state.value.postGroup = res.data.postGroup;
};

const getAuths = async () => {
    const res = await getAuthList();
    state.value.auths = res.data;
};
const getOnlines = async () => {
    const res = await getOnline();
    state.value.devices = res.rows;
};
</script>

<style lang="scss" scoped>
/* 暗黑色主题变量 */
.modal-overlay {
    --dm-bg-overlay: rgba(0, 0, 0, 0.75);
    --dm-bg-main: #1e293b;
    /* 主内容区背景 */
    --dm-bg-sidebar: #0f172a;
    /* 侧边栏背景 */
    --dm-bg-card: #0f172a;
    /* 卡片/输入框深色背景 */
    --dm-border: #334155;
    /* 边框颜色 */
    --dm-border-light: #475569;
    --dm-text-main: #f8fafc;
    /* 主要文字颜色 */
    --dm-text-muted: #94a3b8;
    /* 次要文字颜色 */
    --dm-primary: #3b82f6;
    /* 品牌蓝 */
    --dm-primary-hover: #2563eb;
    --dm-primary-light: rgba(59, 130, 246, 0.15);
    --dm-danger: #ef4444;
    --dm-success: #22c55e;
}

.modal-overlay {
    inset: 0;
    background: var(--dm-bg-overlay);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;

    &.is-open {
        opacity: 1;
        pointer-events: auto;
    }
}

.modal-box {
    position: relative;
    background: var(--dm-bg-main);
    width: 100%;
    max-width: 1024px;
    height: 700px;
    max-height: 90vh;
    border-radius: 16px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transform: scale(0.95);
    transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid var(--dm-border);

    @media (min-width: 640px) {
        flex-direction: row;
    }

    &.is-open {
        transform: scale(1);
    }

    .close-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        z-index: 10;
        padding: 8px;
        background: transparent;
        border: none;
        color: var(--dm-text-muted);
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            color: var(--dm-text-main);
            background: rgba(255, 255, 255, 0.1);
        }
    }
}

/* Sidebar */
.sidebar {
    width: 256px;
    background: var(--dm-bg-sidebar);
    border-right: 1px solid var(--dm-border);
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin-bottom: 0px !important;

    .user-summary {
        padding: 32px;
        padding-bottom: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-bottom: 1px solid var(--dm-border);

        .avatar-wrapper {
            position: relative;
            margin-bottom: 16px;

            img {
                width: 80px;
                height: 80px;
                border-radius: 50%;
                border: 2px solid var(--dm-border);
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);
                object-fit: cover;
            }

            .status-dot {
                position: absolute;
                bottom: 2px;
                right: 2px;
                width: 14px;
                height: 14px;
                background: var(--dm-success);
                border-radius: 50%;
                border: 2px solid var(--dm-bg-sidebar);
            }
        }

        h3 {
            font-size: 18px;
            font-weight: bold;
            color: var(--dm-text-main);
        }

        .badge {
            font-size: 12px;
            color: #60a5fa;
            background: var(--dm-primary-light);
            padding: 4px 10px;
            border-radius: 999px;
            margin-top: 8px;
            font-weight: 500;
        }
    }

    .tab-nav {
        flex: 1;
        padding: 16px 0;
        display: flex;
        flex-direction: column;

        .tab-btn {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 16px 32px;
            color: var(--dm-text-muted);
            background: transparent;
            border: none;
            border-right: 3px solid transparent;
            text-align: left;
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
                background: rgba(255, 255, 255, 0.03);
                color: var(--dm-text-main);
            }

            &.active {
                background: var(--dm-primary-light);
                color: var(--dm-primary);
                font-weight: 700;
                border-right-color: var(--dm-primary);
            }
        }
    }

    .sidebar-footer {
        padding: 24px;
        border-top: 1px solid var(--dm-border);

        .logout-btn {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            color: var(--dm-danger);
            font-weight: 500;
            background: transparent;
            border: none;
            cursor: pointer;
            transition: opacity 0.2s;

            &:hover {
                opacity: 0.8;
            }
        }
    }
}

/* Tab Content area */
.tab-content-container {
    flex: 1;
    background: var(--dm-bg-main);
    position: relative;
    overflow-y: auto;

    /* Scrollbar */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: var(--dm-border-light);
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: var(--dm-text-muted);
    }

    .tab-pane {
        padding: 40px;
        height: 100%;
        display: flex;
        flex-direction: column;
        animation: fadeIn 0.3s ease-out forwards;

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(10px);
            }

            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .pane-header {
            margin-bottom: 12px;

            h2 {
                font-size: 20px;
                font-weight: bold;
                color: var(--dm-text-main);
            }

            p {
                color: var(--dm-text-muted);
                font-size: 14px;
                margin-top: 4px;
            }
        }

        /* === Element Plus Form Overrides for Dark Theme === */
        .custom-el-form {
            max-width: 512px;

            :deep(.el-form-item__label) {
                color: #cbd5e1;
                font-weight: bold;
                padding-bottom: 8px;
            }

            /* Compact labels for security tab */
            .compact-label :deep(.el-form-item__label) {
                font-size: 12px;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                color: var(--dm-text-muted);
            }

            :deep(.el-input__wrapper) {
                background-color: var(--dm-bg-card);
                box-shadow: 0 0 0 1px var(--dm-border) inset;
                border-radius: 12px;
            }

            :deep(.el-input__wrapper.is-focus) {
                box-shadow: 0 0 0 1px var(--dm-primary) inset !important;
            }

            :deep(.el-input__inner) {
                color: var(--dm-text-main);
            }

            :deep(.el-radio__label) {
                color: var(--dm-text-muted);
                transition: color 0.2s;
            }

            :deep(.el-radio.is-checked .el-radio__label) {
                color: var(--dm-primary);
                font-weight: 500;
            }

            :deep(.el-divider) {
                border-color: var(--dm-border);
                margin: 20px 0;
            }
        }

        .pane-footer {
            margin-top: auto;
            padding-top: 32px;
            border-top: 1px solid var(--dm-border);

            .el-button--primary {
                border-radius: 12px;
                font-weight: 500;
                background-color: var(--dm-primary);
                border-color: var(--dm-primary);

                &:hover {
                    background-color: var(--dm-primary-hover);
                    border-color: var(--dm-primary-hover);
                }
            }
        }

        /* Tab 2 Security */
        .security-card {
            max-width: 512px;
            background: var(--dm-bg-card);
            border: 1px solid var(--dm-border);
            border-radius: 16px;
            padding: 24px;
            margin-bottom: 32px;

            h3 {
                font-size: 14px;
                font-weight: bold;
                color: var(--dm-text-main);
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 24px;

                svg {
                    color: var(--dm-primary);
                }
            }

            .password-strength {
                display: flex;
                gap: 4px;
                margin-top: -4px;
                margin-bottom: 4px;

                .bar {
                    height: 4px;
                    flex: 1;
                    border-radius: 999px;
                }

                .red {
                    background: var(--dm-danger);
                }

                .amber {
                    background: #fbbf24;
                }

                .gray {
                    background: var(--dm-border);
                }
            }

            .strength-text {
                font-size: 10px;
                color: var(--dm-text-muted);
            }

            .w-full {
                width: 100%;
            }

            .mt-4 {
                margin-top: 16px;
            }

            .btn-dark {
                border-radius: 12px;
                font-weight: 500;
                border-color: var(--dm-border) !important;
                color: var(--dm-text-main) !important;
                transition: all 0.2s;

                &:hover {
                    background-color: var(--dm-border-light) !important;
                    border-color: var(--dm-border-light) !important;
                }
            }
        }

        .info-alert {
            display: flex;
            gap: 16px;
            padding: 16px;
            background: var(--dm-primary-light);
            border: 1px solid rgba(59, 130, 246, 0.3);
            border-radius: 12px;
            color: #93c5fd;
            font-size: 14px;
            line-height: 1.5;

            svg {
                flex-shrink: 0;
                color: var(--dm-primary);
                margin-top: 2px;
            }
        }

        /* Tab 3 Settings */
        .settings-section {
            max-width: 512px;

            h3 {
                font-size: 14px;
                font-weight: bold;
                color: var(--dm-text-main);
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 16px;

                svg {
                    color: var(--dm-primary);
                }
            }

            .radio-list-card {
                background: var(--dm-bg-card);
                border: 1px solid var(--dm-border);
                padding: 8px;
                border-radius: 16px;
                display: flex;
                flex-direction: column;
                gap: 12px;

                .radio-card-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 16px;
                    border-radius: 12px;
                    border: 1px solid transparent;
                    cursor: pointer;
                    transition: all 0.2s;

                    &:hover {
                        background: var(--dm-bg-main);
                    }

                    &:has(input:checked) {
                        background: var(--dm-primary-light);
                        border-color: rgba(59, 130, 246, 0.3);
                    }

                    .item-left {
                        display: flex;
                        align-items: center;
                        gap: 12px;

                        .icon-box {
                            width: 32px;
                            height: 32px;
                            background: var(--dm-bg-main);
                            color: var(--dm-text-muted);
                            border-radius: 8px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            font-weight: 500;
                            transition: all 0.2s;
                            border: 1px solid var(--dm-border);

                            &.active {
                                background: var(--dm-primary);
                                color: white;
                                border-color: var(--dm-primary);
                            }
                        }

                        .title {
                            font-size: 14px;
                            font-weight: bold;
                            color: var(--dm-text-main);
                        }

                        .subtitle {
                            font-size: 12px;
                            color: var(--dm-text-muted);
                        }
                    }

                    .item-right {
                        position: relative;
                        display: flex;
                        align-items: center;

                        input[type="radio"] {
                            opacity: 0;
                            position: absolute;
                            width: 20px;
                            height: 20px;
                            z-index: 1;
                            cursor: pointer;
                        }

                        .custom-radio {
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            border: 2px solid var(--dm-border-light);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            transition: all 0.2s;
                        }

                        input:checked+.custom-radio {
                            background: var(--dm-primary);
                            border-color: var(--dm-primary);
                        }
                    }
                }
            }

            .helper-text {
                font-size: 12px;
                color: var(--dm-text-muted);
                margin-top: 12px;
                padding: 0 8px;
            }
        }
    }
}

/* Toast Notification */
.toast-notification {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%) translateY(20px);
    background: var(--dm-bg-card);
    border: 1px solid var(--dm-border);
    color: var(--dm-text-main);
    padding: 12px 24px;
    border-radius: 999px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    gap: 12px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 60;

    &.is-visible {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }

    span {
        font-size: 14px;
        font-weight: 500;
    }
}
</style>
